import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10.076 20.245H4.88a1.15 1.15 0 01-1.15-1.15l.001-5.195a1.15 1.15 0 012.3.001l-.001 4.045h4.047a1.15 1.15 0 010 2.3zM19.12 11.249a1.15 1.15 0 01-1.15-1.149l-.001-4.045h-4.043a1.15 1.15 0 010-2.3h5.194a1.15 1.15 0 011.15 1.149l.001 5.195a1.15 1.15 0 01-1.15 1.15z"
}), 'Enlarge');